<div class="validation-detail">
  <app-accordion
    [validationSummaryItems]="validationSummaryItem?.data"
    [readOnly]="readOnly"
  ></app-accordion>
</div>
